import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">

        <img src={logo} className="App-logo" alt="logo" />

        <p>
        This site is currently under construction
        </p>
        <a
          className="App-link"
          href="https://linkedin.com/in/erapple"
          target="_blank"
          rel="noopener noreferrer"
        >
          Check Me Out on LinkedIn
        </a>
      </header>
    </div>
  );
}

export default App;
